import { render, staticRenderFns } from "./ReportMenuSummarySection.vue?vue&type=template&id=d60c8234&"
import script from "./ReportMenuSummarySection.vue?vue&type=script&lang=js&"
export * from "./ReportMenuSummarySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d60c8234')) {
      api.createRecord('d60c8234', component.options)
    } else {
      api.reload('d60c8234', component.options)
    }
    module.hot.accept("./ReportMenuSummarySection.vue?vue&type=template&id=d60c8234&", function () {
      api.rerender('d60c8234', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/report/ReportMenu/ReportMenuSummarySection/ReportMenuSummarySection.vue"
export default component.exports